<template>
    <form-row title="Clear to Close?">
        <div class="flex flex-1 items-center">
            <input-radio-boolean
                name="clear_to_close"
                :value="mortgage.clear_to_close"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
